import { useState, useEffect } from 'react';
import { countries, currencies } from '../Components/Enums/DataEnums';
import { getAgencyData } from '../Utils/Storage';

export const useCurrency = (fallbackCountryID = null) => {
  const [currencySymbol, setCurrencySymbol] = useState('₹');

  useEffect(() => {
    let countryID = null;

    // First try to get CountryID from localStorage (authenticated users)
    try {
      countryID = getAgencyData()?.CountryID;
    } catch (err) {
      console.warn('Failed to parse agency data from localStorage', err);
    }

    // If no localStorage data, use the fallback country ID
    if (!countryID && fallbackCountryID) {
      countryID = fallbackCountryID;
    }

    // Default to CountryID 1 (India) if no country ID found
    if (!countryID) {
      countryID = 1;
    }
    
    // Find country by CountryID
    const country = countries.find(c => c.CountryID === countryID);
    
    if (country) {
      // Find currency by CurrencyID
      const currency = currencies.find(curr => curr.CurrencyID === country.CurrencyID);
      
      if (currency) {
        setCurrencySymbol(currency.CurrencySymbol);
      }
    }
  }, [fallbackCountryID]);

  return currencySymbol;
};